import React from "react";
import { ReactComponent as BakingIcon } from "../../images/baking-icon.svg";
import PlaceholderImage from "../../images/placeholder-image.png";
import {
  CardInformation,
  IconWrapper,
  Image,
  Text,
  TextWrapper,
  Title,
  TitleWrapper,
} from "./BakeCard.styles";

export const PlaceholderCard: React.FC = () => {
  return (
    <>
      <Image src={PlaceholderImage} />
      <CardInformation>
        <TitleWrapper>
          <IconWrapper>
            <BakingIcon />
          </IconWrapper>
          <TextWrapper>
            <Title>Next Bake</Title>
            <Text>Coming Soon</Text>
          </TextWrapper>
        </TitleWrapper>
      </CardInformation>
    </>
  );
};
